import { render, staticRenderFns } from "./formfield.vue?vue&type=template&id=5ac9e7de"
import script from "./formfield.vue?vue&type=script&lang=js"
export * from "./formfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports